// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1OwWi","footer":"Form_footer__30bKN"};